//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AcBreadcrumbs from "@/components/Main/AppBreadcrumbs/ac-breadcrumbs.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import { ENGINE_REST_PATH } from "@/assets/js/appConfig";

const applicationImage = "/identity/companyInfo/logo/appBuilderLogo";
const checkForChanges = () => document.querySelector(".app__saveBtn");

export default {
    name: "AppBreadcrumbs",
    components: { AcBreadcrumbs, AQTooltip, AQDialog },
    data() {
        return {
            isOpen: false,
            dlgCallback: null
        };
    },
    computed: {
        ...mapGetters("apps", ["currentApp"]),
        dlgLang() {
            return {
                title: this.$t("documents.wrnTitle"),
                message: this.$t("userInterface.leavePageMsg")
            };
        },
        imgSrc() {
            const { imageId } = this.currentApp;
            return imageId ? `${ENGINE_REST_PATH}/app/files/${imageId}/IMAGE` : applicationImage;
        },
        metaBreadcrumbs() {
            const { meta = {} } = this.$route;
            return meta.breadcrumbs || { type: "app", path: [] };
        },
        isPlatform() {
            return this.bcType !== "edit";
        },
        bcType() {
            return this.metaBreadcrumbs.type;
        },
        hybrid() {
            const { hybrid = false } = this.metaBreadcrumbs;
            return hybrid;
        },
        bcPath() {
            const { path } = this.metaBreadcrumbs;
            return typeof path === "function" ? path() : path;
        }
    },
    mounted() {
        // alert(this.link);
    },
    methods: {
        onDlgOk() {
            this.$store.commit("main/setInterfaceDirty", false);
            const availableRoutes = ["perspectiveBuilder"];
            const { name: routeName } = this.$route || {};
            this.isOpen = false;
            if (availableRoutes.includes(routeName)) {
                this.$root.$emit(`confirm_${routeName}_unsaved_changes`);
            }

            if (this.dlgCallback) {
                this.$nextTick(() => {
                    this.dlgCallback();
                    this.dlgCallback = null;
                });
            }
        },
        onDlgCancel() {
            this.isOpen = false;
            this.dlgCallback = null;
        },
        onCrumbClick(link) {
            const { path } = this.$route;
            if (checkForChanges()) {
                if (link === "__reset__" || path === link) {
                    this.dlgCallback = () => this.goToLink(link);
                    this.isOpen = true;
                } else {
                    this.goToLink(link);
                }
            } else {
                this.goToLink(link);
            }
        },
        onAvatarClick() {
            this.$router.push({ name: "dashboard" });
        },
        goToLink(link) {
            if (link === "/dataStore/dataTablesLegacy") {
                this.$store.commit("GDM/setEntitySelected");
            } else if (link === "/dataStore/dataTables") {
                this.$store.commit("dataStore/setEntitySelected");
            }

            if (link.startsWith("/")) {
                this.$router.push({ path: link });
            } else {
                this.$router.push({ name: link });
            }
        },
        onOpen({ ev, guid }) {
            if (checkForChanges()) {
                this.dlgCallback = () => this.$root.$emit(ev, guid);
                this.isOpen = true;
            } else {
                this.$root.$emit(ev, guid);
            }
        }
    }
};
